import { Link } from 'react-router-dom';
import { Menu, LayoutDashboard, Box } from 'lucide-react';
import { Button } from '../../ui/button';
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '../../ui/sheet';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../ui/accordion';
import { iconMap } from './iconMap';
import { getVisibleSections } from './MegaMenu';

export const MobileNavigation = ({ groups, canRead }) => {
  const visibleGroups = groups
    .map(group => ({ ...group, sections: getVisibleSections(group.sections, canRead) }))
    .filter(group => group.sections.length > 0);

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="md:hidden h-9 w-9 text-slate-400 hover:bg-white/5 hover:text-white"
          data-testid="mobile-navigation"
        >
          <Menu className="h-5 w-5" strokeWidth={1.5} />
          <span className="sr-only">Abrir navegación</span>
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="flex w-[min(24rem,calc(100vw-1rem))] flex-col border-slate-700/50 bg-slate-900 p-0 text-slate-100 sm:max-w-none">
        <SheetHeader className="border-b border-slate-700/50 px-5 py-4 pr-12 text-left">
          <SheetTitle className="text-base text-white">Navegación</SheetTitle>
          <SheetDescription className="text-xs text-slate-400">Módulos disponibles según tus permisos</SheetDescription>
        </SheetHeader>
        <div className="min-h-0 flex-1 overflow-y-auto px-5 py-3">
          <SheetClose asChild>
            <Link to="/" className="flex items-center gap-2 rounded-md px-2 py-2.5 text-sm text-slate-300 hover:bg-white/5 hover:text-white">
              <LayoutDashboard className="h-4 w-4 text-primary/70" strokeWidth={1.5} />
              Dashboard
            </Link>
          </SheetClose>
          <Accordion type="multiple" className="w-full">
            {visibleGroups.map(({ label, Icon, sections }) => (
              <AccordionItem key={label} value={label} className="border-slate-700/50">
                <AccordionTrigger className="px-2 py-3 text-slate-200 hover:no-underline hover:text-white">
                  <span className="flex items-center gap-2">
                    <Icon className="h-4 w-4 text-primary/70" strokeWidth={1.5} />
                    {label}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-2">
                  {sections.map((section, sectionIndex) => (
                    <div key={`${section.header || 'items'}-${sectionIndex}`} className="pb-2">
                      {section.header && (
                        <p className="px-2 pb-1 pt-1 text-[10px] font-semibold tracking-wider text-slate-500">
                          {section.header}
                        </p>
                      )}
                      {section.items.map((item) => {
                        const ItemIcon = iconMap[item.name] || Box;
                        return (
                          <div key={item.path}>
                            {item.subHeader && (
                              <p className="px-2 pt-2 text-[9px] font-semibold uppercase tracking-wider text-slate-600">
                                {item.subHeader}
                              </p>
                            )}
                            <SheetClose asChild>
                              <Link to={item.path} className="flex items-center gap-2 rounded-md px-2 py-2 text-sm text-slate-300 hover:bg-white/5 hover:text-white">
                                <ItemIcon className="h-3.5 w-3.5 text-primary/70" strokeWidth={1.5} />
                                {item.name}
                              </Link>
                            </SheetClose>
                          </div>
                        );
                      })}
                    </div>
                  ))}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </SheetContent>
    </Sheet>
  );
};
